import { render, staticRenderFns } from "./Primary.vue?vue&type=template&id=441ad492&scoped=true"
import script from "./Primary.vue?vue&type=script&lang=js"
export * from "./Primary.vue?vue&type=script&lang=js"
import style0 from "./Primary.vue?vue&type=style&index=0&id=441ad492&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441ad492",
  null
  
)

export default component.exports